﻿import { ApiCaller } from 'apis/ApiCaller';
import { IJoyride } from 'types';

/**
 * Represents an api handler for the JoyrideController.
 * */
export class JoyrideApi {

    private static apiCaller = new ApiCaller('Joyride');

    public static GetIntrosByPage(pageURL: string): Promise<IJoyride[]> {

        return this.apiCaller.GET<IJoyride[]>('GetIntrosByPage', { cultureId: 1, pageURL });

    }

    public static SetJoyrideIntroComplete(claimUrl: string): Promise<any> {

        return this.apiCaller.GET<any>('SetJoyrideIntroComplete', { claimUrl });

    }

}